import { Button } from '@mantine/core';
import React, { useState } from 'react';
import { FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import victory from "../images/featured/victory.png";
function Popup() {
    const [click , setClick] =useState(false);

    const handleHide  =(e) => {
      setClick(!click)
    }

  return (
    <div className={click ? "home_page_popup display-none" : "home_page_popup"}>
       <div className="popup_wrapper">
       <div className="close_icon ">
            <FaTimes onClick={handleHide} />
        </div>
      <div className="popUp_flex">
      <div className="icon-area">
           <img src={victory} alt="" />
        </div>
        <div className="text-area">
           <h4>Hey! you'll got a big surprise</h4>
           <p>I provide a chip price for creating modern website with full functionality. Chack it out. </p>
           <div className="btn-area">
           <Link to="/pricing"> <Button>Click Here</Button></Link>
        </div>
        </div>
      
      </div>
      
       </div>
    </div>
  )
}

export default Popup